import styles from './loadTestSettingsModal.module.scss';
import { useTranslation } from "react-i18next";
import { Input } from "../../shared/components/input/input";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  number,
  object,
  string
} from "yup";
import { LoadTestSettings } from "../../types/loadTestTypes";
import { ModalWindow } from "../../shared/components/modalWindow/modalWindow";
import { TextArea } from "../../shared/components/textArea/textArea";

type LoadTestSettingsModalProps = {
  onClose: (settings?: LoadTestSettings) => void;
}

export const LoadTestSettingsModal = ({ onClose }: LoadTestSettingsModalProps) => {
  const { t } = useTranslation();

  const schema = object({
    numberOfThreads: number().integer(t("common.notValid")).required(t("common.notValid")).typeError(t("common.notValid"))
      .max(10000, t("common.notValid")).min(1, t("common.notValid")),
    rampUpPeriod: number().required(t("common.notValid")).typeError(t("common.notValid"))
      .max(10000, t("common.notValid")).min(1, t("common.notValid")),
    loopCount: number().required(t("common.notValid")).typeError(t("common.notValid"))
      .max(10000, t("common.notValid")).min(1, t("common.notValid")),
    comment: string(),
  })

  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange"
  })

  const onClickRun = (): void => {
    handleSubmit((value) => {
      onClose({
        comment: value.comment || "",
        loopCount: value.loopCount,
        numberOfThreads: value.numberOfThreads,
        rampUpPeriod: value.rampUpPeriod
      })
    })();
  }

  return (
    <ModalWindow onClose={() => onClose()}
                 title={t("loadTestSettings.title")}
                 width={380}
                 children={
                   <div className={styles.container}>
                     <div className={styles.inputContainer}>
                       <span className={styles.required}>{t("loadTestSettings.numberOfThreads")}</span>
                       <div className={styles.input}>
                         <Input control={control}
                                name={"numberOfThreads"}
                                maxLength={100}
                                error={!!errors.numberOfThreads ? errors.numberOfThreads.message : ""}/>
                       </div>
                     </div>
                     <div className={styles.inputContainer}>
                       <span className={styles.required}>{t("loadTestSettings.rampUpPeriod")}</span>
                       <div className={styles.input}>
                         <Input control={control}
                                name={"rampUpPeriod"}
                                maxLength={4}
                                type={"number"}
                                error={!!errors.rampUpPeriod ? errors.rampUpPeriod.message : ""}/>
                       </div>
                     </div>
                     <div className={styles.inputContainer}>
                       <span className={styles.required}>{t("loadTestSettings.loopCount")}</span>
                       <div className={styles.input}>
                         <Input control={control}
                                name={"loopCount"}
                                maxLength={4}
                                type={"number"}
                                error={!!errors.loopCount ? errors.loopCount.message : ""}/>
                       </div>
                     </div>
                     <div className={styles.commentContainer}>
                       <span>{t("loadTestSettings.comment")}</span>
                       <TextArea control={control}
                                 name={"comment"}
                                 maxLength={57000}/>
                     </div>
                     <div className={styles.buttonsContainer}>
                       <div className={styles.buttons}>
                         <button className={styles.cancel}
                                 onClick={() => onClose()}>{t("common.cancel")}</button>
                         <button className={styles.run}
                                 onClick={onClickRun}>{t("loadTestSettings.run")}</button>
                       </div>
                     </div>
                   </div>
                 }/>

  );
}